module.exports = __webpack_public_path__ + "img/logo.26770ca6.svg";